import { render, staticRenderFns } from "./SelectDiscountRule.vue?vue&type=template&id=2f8b35f6"
import script from "./SelectDiscountRule.vue?vue&type=script&lang=js"
export * from "./SelectDiscountRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports